import { Box, Button, IconButton, List, ListItemButton, ListItemText, Typography, Drawer, Menu, MenuItem, Tooltip, ListItemIcon ,Badge,Divider} from '@mui/material'
import { useEffect } from 'react'
import { useNavigate, useLocation, NavLink } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react';
import { useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import axios from 'axios';
import { ReactComponent as DropDownIcon } from '../img/dropdownIcon.svg';

import { ReactComponent as LeftArrowIcon } from '../img/LeftArrowIcon.svg';
import { ReactComponent as RightArrowIcon } from '../img/RightArrowIcon.svg';

import { ReactComponent as NotificationIcon } from '../img/topbar/notificationIcon.svg';
import { ReactComponent as Logo } from "../img/logo.svg"
import { ReactComponent as MobileLogo } from "../img/mobileLogo2.svg"

import { ReactComponent as AvatarIcon } from '../img/AvatarSm.svg';
import CloseIcon from '@mui/icons-material/Close';
import ToastContainer from '../pages/Notifications/ToastContainer';
import { onMessage } from 'firebase/messaging';
import { messaging } from '../firebase';
import { toast } from "react-toastify";
import StyledToastContainer from '../pages/Notifications/ToastContainer';
import { useNotificationCount } from '../redux/apiCalls';
import { useQueryClient } from '@tanstack/react-query';
import { ReactComponent as Updates } from "../img/notifications/Updates.svg"
import { ReactComponent as AccountActivity } from "../img/notifications/Account Activity.svg"
import { ReactComponent as Alert } from "../img/notifications/Alert.svg"
import { ReactComponent as Announcement } from "../img/notifications/Announcement.svg"
import { ReactComponent as General } from "../img/notifications/General.svg"
import NotificationToast from '../pages/Notifications/NotificationToast';
import { useOnlineStatus } from '../hooks/useOnlineStatus';
import OfflineStatus from '../img/offlineStatus.png';
import BottomLogo from '../img/bottomLogo.png';

import { ApiService } from '../API/AxiosInstance';
import { useAuthUser } from '../hooks/useAuthUser';
import { deleteDeviceToken } from '../utils/deviceTokenDelete';
// import { colors } from '../Theme/tokens';
import { useColors, useColorMode } from '../Theme/ColorModeContext';
// import { ReactComponent as OverviewIcon } from "../img/topbar/overviewIcon.svg"
import { pageConfig } from '../utils/pageConfig';
import { ReactComponent as NewsIcon } from "../img/news/newsIcon.svg"
import { ReactComponent as NewsFocusedIcon } from "../img/newsFocusedIcon.svg"
import { ReactComponent as ProductIcon } from "../img/products/productIcon.svg"
import { ReactComponent as ProductFocusedIcon } from "../img/productFocusedIcon.svg"
import { ReactComponent as CryptoIcon } from "../img/cryptoIcon.svg"
import { ReactComponent as CryptoFocusedIcon } from "../img/cryptoFocusedIcon.svg"
import { ReactComponent as OverviewIcon } from "../img/overviewIcon.svg"
import { ReactComponent as OverviewFocusedIcon } from "../img/overviewFocusedIcon.svg"
import { ReactComponent as PortfolioIcon } from "../img/portfolioIcon.svg" 
import { ReactComponent as PortfolioFocusedIcon } from "../img/portfolioFocusedIcon.svg" 
import { ReactComponent as TransactionsIcon } from "../img/transactionsIcon.svg"
import { ReactComponent as TransactionsFocusedIcon } from "../img/transactionsFocusedIcon.svg"
import { ReactComponent as SettingsIcon } from "../img/settingsIcon.svg"
import { ReactComponent as SettingsFocusedIcon } from "../img/settingsFocusedIcon.svg"
import { ReactComponent as FooterLogo } from "../img/footerLogo.svg"
import { ReactComponent as LogoutIcon } from "../img/logoutIcon.svg"
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
axios.defaults.withCredentials = true

const menus = [{
    id: 1,
    nav_bar_name: "Overview",
    isdrobdown: 0,
    uri_link: "/",
    icon_sm: <OverviewIcon />,
    icon_lg: <OverviewIcon />,
    focused_icon: <OverviewFocusedIcon />
},
{
    id: 2,
    nav_bar_name: "Crypto Prices",
    isdrobdown: 0,
    uri_link: "/Cryptoprices",
    icon_sm: <CryptoIcon />,
    icon_lg: <CryptoIcon />,
    focused_icon: <CryptoFocusedIcon />
},
{
    id: 3,
    nav_bar_name: "Products",
    isdrobdown: 0,
    uri_link: "/Products",
    icon_sm: <ProductIcon />,   
    icon_lg: <ProductIcon />,
    focused_icon: <ProductFocusedIcon />
},
{
    id: 4,
    nav_bar_name: "My Portfolio",
    isdrobdown: 0,
    uri_link: "/Portfolio",
    icon_sm: <PortfolioIcon />,
    icon_lg: <PortfolioIcon />,
    focused_icon: <PortfolioFocusedIcon />
},

{
    id: 5,
    nav_bar_name: "News",
    isdrobdown: 0,
    uri_link: "/News",
    icon_sm: < NewsIcon />,
    icon_lg: <NewsIcon />,
    focused_icon: <NewsFocusedIcon />
},
{
    id: 7,
    nav_bar_name: "Transactions",
    isdrobdown: 0,
    uri_link: "/Transactions",
    icon_sm: <TransactionsIcon />,
    icon_lg: <TransactionsIcon />,
    focused_icon: <TransactionsFocusedIcon />

},
{
    id: 9,
    nav_bar_name: "Settings",
    isdrobdown: 0,
    uri_link: "/Settings",
    icon_sm: <SettingsIcon />,
    icon_lg: <SettingsIcon />,
    focused_icon: <SettingsFocusedIcon />
},

]

const notificationIcons = {
  1: General,
  2: Announcement,
  3: Alert,
  4: AccountActivity,
  5: Updates
};


const SideBar = ({ children, logoutClicked }) => {
    const navigate = useNavigate();
    const location = useLocation()
    const colors = useColors()
    const { mode, toggleColorMode } = useColorMode();
    const { logout, user, isAuthenticated, loginWithRedirect } = useAuth0();
    const [innerHeight, setInnerHeight] = useState(window.innerHeight);
    const [mobileDrawer, setMobileDrawer] = useState(false);
    const [sidebaropen, setSideBarOpen] = useState(true)
    const firstName = localStorage.getItem('firstName') ? localStorage.getItem('firstName') : ''
    const lastName = localStorage.getItem('lastName') ? localStorage.getItem('lastName') : ''
    const [userId, setUserId] = useState(localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).sub_id : '')
    const drawerWidth = sidebaropen ? 250 : 170;
    const drawerRootWidth = sidebaropen ? 200 : 121;
    const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
    const currentYear = new Date().getFullYear()
    const [anchorEl, setAnchorEl] = useState(null);
    const [logoutAnchorEl, setLogoutAnchorEl] = useState(null);
    const [notificationList,setNotificationList] = useState([])
    const queryClient = useQueryClient();
    const {data: userData} = useAuthUser()
    const isOnline = useOnlineStatus();
    const { pathname } = useLocation();


    const page =
    Object.entries(pageConfig).find(([route]) => {
      if (route === "/") return pathname === "/";
      return pathname.startsWith(route);
    })?.[1] || {
      title: "Dashboard",
      icon: <OverviewIcon />,
    };

    console.log("pathname ",pathname,page)
    const [toasts, setToasts] = useState([]);
      const { data: notificationCount, isLoading, error: notificationCountError } =  useNotificationCount(userData?.sub_id);

useEffect(() => {
  // Foreground messages (tab focused)
  const unsubscribe = onMessage(messaging, (payload) => {
    console.log("sidebafrnewFCMessagenav", payload);
    handleNotification(payload);
  });

  // Background messages (tab unfocused/minimized) relayed from the SW
  const channel = new BroadcastChannel('fcm-channel');
  channel.onmessage = (event) => {
    console.log("bg message via broadcast channel", event.data);
    handleNotification(event.data);
  };

  function handleNotification(payload) {
    const title =
      payload?.notification?.title || payload?.data?.title || "New Notification";
    const body = payload?.notification?.body || payload?.data?.body || "";

    toast.info(
      <NotificationToast title={title} body={body} />,
      {
        autoClose: 4000,
        hideProgressBar: true,
      }
    );

    queryClient.invalidateQueries({
      queryKey: ['notification-count', userId],
    });
  }

  return () => {
    unsubscribe();
    channel.close();
  };
}, []);

  useEffect(() => {
    if(!isOnline) {
              toast.info(
            <NotificationToast icon={OfflineStatus} body={"Connection timed out! Please check your internet connection refresh."} />,
            {
                autoClose: 4000,
                hideProgressBar: true,
                icon: false,
            }
            );
    }
  },[isOnline])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogoutClick = (event) => {
        setLogoutAnchorEl(event.currentTarget)
    }

    const handleLogoutClose = () => {
        setLogoutAnchorEl(null);
    };

    const handleNotifiationMenuClick = (event) => {
        setNotificationAnchorEl(event.currentTarget);
    };

    const handleNotificationMenuClose = () => {
        setNotificationAnchorEl(null);
    };

    const handleNavigate = (path) => {
        navigate(path);
        handleClose();
    };
    console.log("notificationList ",notificationList)

    useEffect(() => {
        if (isAuthenticated && user) {
            if (localStorage.getItem('userData') === null) {
                localStorage.setItem('userData', JSON.stringify(user));
            }
             getNotifications(user?.sub_id)
        }
    }, [isAuthenticated, user]);

    const handleLogout = async() => {
        try {
                await deleteDeviceToken()
                await axios.post(`${process.env.REACT_APP_BASE_URL}users/${user?.sub_id}/sessions/invalidate`, {}, {headers:{'Authorization': `Bearer ${localStorage.getItem('token') ? localStorage.getItem('token') : null}`}})
                await ApiService().get('oauth/logout');
                localStorage.removeItem('userData')
                localStorage.removeItem('token')
                document.cookie.split(";").forEach(function(c) {
                    document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/");
                  });
                  localStorage.clear()
                localStorage.setItem('logout',true)
                localStorage.removeItem('login')
                  logout({ logoutParams: { returnTo: window.location.origin } })

        } catch(error) {
            console.log("handleLogout error ",error)
            if(error?.status === 401) {
                await deleteDeviceToken()
                await ApiService().get('oauth/logout');
                localStorage.clear()
                localStorage.setItem('logout',true)
                localStorage.removeItem('login')
                  logout({ logoutParams: { returnTo: window.location.origin } })
            }
        }
    }

    const toggleWebDrawer = () => {
        setSideBarOpen(prevValue => !prevValue);
    }

    useEffect(() => {
        const handleWindowResize = () => {
            setInnerHeight(window.innerHeight);
        };
        window.addEventListener("resize", handleWindowResize);

        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    });

    const getNotifications = async(userId) => {
        try {
            const response = await ApiService().get(`users/${userId}/notifications`);
            if(response?.status === 200 && response?.data?.notifications?.length >0) {
                setNotificationList(response?.data?.notifications?.slice(0,3))
            }
        } catch(error) {

        } finally {

        }
    }

    const IconContainer = (mainCategoryId) => {
        
        const Icon = notificationIcons[mainCategoryId.mainCategoryId];
        return(
            <Box sx={{width:"36px", height:"36px", backgroundColor: colors.background.iconBox, borderRadius:"7.58px", display:"flex", justifyContent:"center", alignItems:"center" }}>
                {Icon ? <Icon /> : <General />}
            </Box>
        )
    }

    const handleViewAll = () => {
        setNotificationAnchorEl(null)
        navigate('/notification')
    }

    return (

        <Box>
            <Box sx={{ display: "flex", height: "calc(100% - 65px)", position: 'relative' }} >
                <IconButton
                    onClick={toggleWebDrawer}
                    component='div'
                    sx={{
                        // display: {
                        //     sm: 'flex',
                        //     xs: 'none',
                        // },
                         display: 'none',
    '@media (min-width:750px)': {
        display: 'flex',
    },
                        position: 'sticky',
                        zIndex: '1201',
                        top: '50%',
                        left: sidebaropen ? '227px' : '145px',
                        width: '50px',
                        height: '50px',
                        backgroundColor: colors.background.paper,
                        borderRadius: '100px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        boxShadow: '0 0 10px 0 rgba(0,0,0,0.2)',
                        color: colors.primary.main,
                        transition: '.4s',
                        visibility:"hidden"
                    }}
                >
                    {sidebaropen ? <LeftArrowIcon sx={{ paddingLeft: '8px',  }} /> : <RightArrowIcon />}
                </IconButton>
                <Drawer
                    sx={{
                        width: drawerRootWidth,
                        flexShrink: 0,
                         display: 'none',
                        '@media (min-width:750px)': {
                            display: 'block',
                        },
                        "& .MuiDrawer-paper": {
                            width: drawerWidth,
                             borderRadius: 0, 
                            '::-webkit-scrollbar': { display: 'none' },
                            '-ms-overflow-style': 'none',
                            'scrollbarWidth': 'none',
                            overflow: 'auto',
                            transition: '.4s',
                            // borderRight: `0.5px solid ${colors.text.tertiary}`,
                        },
                        "& .MuiDrawer-root": {
                            width: drawerRootWidth,
                        },
                        transition: '.4s',
                    }}
                    variant="persistent"
                    anchor="left"
                    open={true}
                >
                    {sidebaropen ?

                        <>
                            <Box sx={{ height: '100px', padding: '15px 10px 10px 20px' }}  >
                                <Logo key={1} style={{height:"55px", width:"200px"}} />
                            </Box>
                            <List>
                                {/* <Typography mb={2} sx={{ fontSize: '15px', fontWeight: 600, letterSpacing: '.3px', color: colors.nav.labelColor, textAlign: 'center' }}>Portfolios</Typography> */}
                                {menus.map((item) => {
                                    return (
                                        <>
                                            <NavLink to={item?.uri_link}>
                                                <ListItemButton sx={{margin:"0 18px", borderRadius:"4px", paddingLeft: '0px', height: '54px', ".MuiListItemText-primary": { color: location?.pathname == item?.uri_link && colors.primary.main }, backgroundColor: location?.pathname == item?.uri_link && colors.nav.activeBackground, '&:hover': { ".MuiListItemText-primary": { color: colors.nav.activeColor }, backgroundColor: colors.nav.activeBackground} }}>
                                                    <Tooltip >
                                                        <ListItemIcon sx={{ minWidth: '40px',p:2}}>
                                                            { location?.pathname == item?.uri_link ? item?.focused_icon : item?.icon_sm}
                                                        </ListItemIcon>
                                                    </Tooltip>
                                                    <ListItemText className='fade-in' sx={{ ".MuiTypography-root": { fontSize: '15px', fontWeight: '500 ', letterSpacing: '.7px', color: location?.pathname == item?.uri_link ? colors.nav.activeColor : colors.text.gray, '&:hover': { color: colors.nav.activeColor } } }} primary={item?.nav_bar_name} />
                                                </ListItemButton>
                                            </NavLink>
                                            {/* {item?.nav_bar_name == 'Transactions' &&
                                                <Typography my={2} sx={{ fontSize: '15px', fontWeight: 600, letterSpacing: '.3px', color: colors.nav.labelColor, textAlign: 'center' }}>Support</Typography>} */}
                                        </>
                                    )
                                })}
                            </List>


                            
                            <Box sx={{ padding: '0 20px 20px 20px', display: 'flex', flexDirection: 'column', gap: '10px',flex:1, justifyContent:"flex-end" }}>
                            {/* <hr style={{ color: colors.text.disabled }} /> */}
                            {/* <Box sx={{display:"flex", justifyContent:"center"}}>
                                <FooterLogo />
                            </Box>
                                                         */}
                            <Box sx={{display:"flex",justifyContent:"center"}}>
                                <Box component={'img'} sx={{width:{xs:"70px",xl:"80px"},height:{xs:"70px",xl:"80px"}}} src={BottomLogo} />
                            </Box>                   
                                <Divider sx={{
                                    border: 0,
                                    borderBottom: `0.5px solid ${colors.border.cardDiv}`,
                                    opacity: 1,
                                    mt: 1
                                }} />
                                <Typography sx={{ fontWeight: 500, fontSize: '13px', color: colors.text.primary, lineHeight: '16px', letterSpacing: '2%' }}>© TradeTogether. {currentYear}</Typography>
                                <Typography sx={{ fontWeight: 500, fontSize: '10px', color: colors.text.secondary, lineHeight: '12px', letterSpacing: '5%' }}>Grow your Wealth in Web3, safely!</Typography>
                                <Box sx={{ display: 'flex', gap: '10px' }}>
                                    <Typography onClick={() => window.open('https://tradetogether.com/terms-of-service/', '_blank')} sx={{ color: colors.text.tertiary, letterSpacing: '5%', fontSize: '10px', lineHeight: '12px', fontWeight: '500', cursor:"pointer" }}>Terms & Condition</Typography>
                                    <Typography sx={{ color: colors.neutral.outlinedText, fontSize: '20px', marginTop: '-15px' }}>.</Typography>
                                    <Typography onClick={() => window.open('https://tradetogether.com/privacy-policy/', '_blank')} sx={{ color: colors.text.tertiary, letterSpacing: '5%', fontSize: '10px', lineHeight: '12px', fontWeight: '500',cursor:"pointer" }}>Privacy Policy</Typography>
                                </Box>
                            </Box>
                        </>
                        :
                        <>
                            <Box my={1} sx={{ height: '60px', padding: '8px 8px 6px 8px' }} >
                                <Logo key={1} width='127px !important' height='33px !important' />
                            </Box>

                            <List>
                                <Typography variant="h5" mb={2} sx={{ color: colors.text.disabled, textAlign: 'center' }}>Portfolios</Typography>
                                {menus.map((item) => {
                                    return (
                                        <>
                                            <Box mt={2}>
                                                <NavLink to={item?.uri_link}>
                                                    <ListItemButton sx={{ mx: !(location?.pathname == item?.uri_link) && 4, borderLeft: location?.pathname == item?.uri_link ? `6px solid ${colors.nav.activeBorder}` : `6px solid ${colors.background.paper}`, borderRadius: !(location?.pathname == item?.uri_link) && '13px', Width: '60px', height: '75px', backgroundColor: location?.pathname == item?.uri_link ? colors.nav.activeBackground : colors.background.default, display: 'flex', justifyContent: 'center', '&:hover': { borderLeft: `6px solid ${colors.nav.activeBorder}`, borderRadius: '0', backgroundColor: colors.nav.activeBackground, mx: 0 } }}>
                                                        <Tooltip >
                                                            <ListItemIcon sx={{ justifyContent: 'center' }}>
                                                                {item?.icon_lg}asd
                                                            </ListItemIcon>
                                                        </Tooltip>
                                                    </ListItemButton>
                                                </NavLink>
                                            </Box>
                                            {item?.nav_bar_name == 'Transactions' &&
                                                <Typography my={2} variant="h5" sx={{ color: colors.text.disabled, textAlign: 'center' }}>Support</Typography>
                                            } </>
                                    )
                                })}
                            </List>
                        </>
                    }
                </Drawer >

                <Box sx={{ overflow: "auto", width: "100%", "::-webkit-scrollbar": { display: "none" }, }} >
                    <Box
                        sx={{
                            height: '70px',
                            width: '100%',
                            // display: {
                            //     sm: 'flex',
                            //     xs: 'none',
                            // },
                        display: 'none',
                        '@media (min-width:750px)': {
                            display: 'flex',
                        },
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: `0.3px solid ${colors.border.default}`,
                        }}
                    >
                        <Box sx={{display:"flex", gap:1, pl:4,flexGrow: 1}}>
                            {/* <IconButton onClick={toggleColorMode} sx={{paddingTop:0}}>
                            {mode === 'dark' ? <LightModeIcon   sx={{ color: colors.text.primary }}/> : <DarkModeIcon  sx={{ color: colors.text.primary }} />}
                            </IconButton> */}
                            {page?.icon}
                            <Typography variant='h2' color='inherit' noWrap sx={{  fontWeight:"550", fontSize:{xs:"20px",lg:"28px"} }}>{page?.title}</Typography>
                        </Box>
                        <Box color='inherit' sx={{ marginRight: '20px', display: 'flex', alignItems: 'center', }}>
                            <IconButton onClick={handleNotifiationMenuClick} sx={{ '&:hover': { backgroundColor: 'Bg_color', }, }}   >
                            {/* <IconButton disabled sx={{ backgroundColor: '#F0F7FD', '&:hover': { backgroundColor: 'Bg_color', }, }}   > */}
                                <Badge
                                    badgeContent={notificationCount}
                                    invisible={!notificationCount}
                                    sx={{
                                    '& .MuiBadge-badge': {
                                        backgroundColor: colors.error.dark,
                                        borderRadius: '100px',
                                        top: -5,
                                        right: -5,
                                        opacity: 1,
                                        color: colors.primary.contrastText,
                                    },
                                    }}
                                >
                                    <NotificationIcon />
                                    </Badge>
                                
                            </IconButton>
                                    <Menu
                                        anchorEl={notificationAnchorEl}
                                        open={Boolean(notificationAnchorEl)}
                                        onClose={handleNotificationMenuClose}
                                        transitionDuration={0}
                                        MenuListProps={{ disablePadding: true }}
                                          anchorOrigin={{
                                            vertical: "bottom", 
                                            horizontal: "right",
                                        }}
                                        transformOrigin={{
                                            vertical: "top",
                                            horizontal: "right",
                                        }}
                                          slotProps={{
                                                paper: {
                                                sx: {
                                                    backgroundColor: colors.background.paper,  
                                                    boxShadow: "0px 4px 24px 0px #00000014;", 
                                                    mt:1,
                                                    borderRadius:"15px"      
                                                },
                                                },
                                            }}
                                            
                                    >
                                        <Box sx={{ borderRadius:"15px", padding:"18px",backgroundColor: colors.background.paper, minWidth:"340px", maxWidth:"340px"}}> 
                                            <Box sx={{display:"flex", justifyContent:"space-between", alignItems:"center", mb:1}}>
                                                <Typography sx={{fontSize:"18px", color: colors.neutral.outlinedText, fontWeight:"600", letterSpacing:"0%" }}>Notifications</Typography>
                                                <IconButton onClick={handleNotificationMenuClose}><CloseIcon /></IconButton>
                                            </Box>
                                            <Box sx={{display:"flex", flexDirection:"column", gap:2}}>
                                               {notificationList?.map((item, index) => (
                                            <Box sx={{
                                                display:"flex", 
                                                justifyContent:"center", 
                                                gap:2, 
                                                padding:"12px", 
                                                backgroundColor: colors.background.paper, 
                                                borderRadius:"12px", 
                                                boxShadow:`0px 1px 5px 0px ${colors.border.card}`,
                                                overflow: "hidden"          // 👈 add
                                                }}>
                                                <IconContainer mainCategoryId={item?.mainCategoryId} />
                                                <Box sx={{
                                                    display:"flex", 
                                                    flexDirection:"column", 
                                                    gap:1, 
                                                    flex:1, 
                                                    minWidth: 0                // 👈 add — this is the key one
                                                }}>
                                                    <Typography sx={{ 
                                                    fontSize:"14px", 
                                                    color: colors.neutral.outlinedText, 
                                                    fontWeight:"600", 
                                                    letterSpacing:"0%",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                    }}>
                                                    {item?.title}
                                                    </Typography>
                                                    <Typography sx={{ 
                                                    fontSize:"10px", 
                                                    color: colors.neutral.subText, 
                                                    fontWeight:"400", 
                                                    letterSpacing:"0.5px",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                    }}>
                                                    {item?.body}
                                                    </Typography>
                                                </Box>
                                                </Box>
                                               ))}
                                            </Box>
                                            {notificationList?.length > 0 && <Box sx={{display:"flex", justifyContent:"flex-end"}}><Button onClick={handleViewAll} sx={{fontSize:"12px", color: colors.text.primary  }}>View All</Button></Box>}
                                        </Box>
                                    </Menu>
                        </Box>

                        {!isAuthenticated && (
                            <Box sx={{ padding: '0 10px', display: 'flex', alignItems: 'center', gap: '10px', }} >
                                <Button sx={{ textTransform: 'none', }} variant='contained' onClick={() => navigate('/signup')} >  Sign Up</Button>
                                <Button sx={{ textTransform: 'none' }} onClick={() => loginWithRedirect()}
                                    variant='contained' >
                                    Login
                                </Button>
                            </Box>
                        )}
                          {/* <Box
            color='inherit'
            sx={{
                cursor:"pointer",
                backgroundColor: colors.background.default,
                padding: '5px 10px',
                marginRight: '40px',
                borderRadius: '10px',
                display: {
                    sm: 'flex',
                    xs: 'none',
                },
                alignItems: 'center',
                maxWidth: '150px',
                overflow: 'hidden', 
            }}
            variant='h5'
            onClick={handleClick} 
        >
            <Box sx={{ flexShrink: 0 }}>
                <AvatarIcon width='38px' height='38px' />
            </Box>
            <Typography 
                variant='h5' 
                pl={1.5} 
                sx={{ 
                    width:"100px",
                    overflow:"hidden",
                    whiteSpace:"nowrap",
                    textOverflow:"ellipsis",
                    textTransform: 'capitalize', 
                    fontSize: '0.875rem', 
                    fontWeight: 600,
                }}
            >
                {user?.nickname ? user.nickname : ''}
            </Typography>
           {isAuthenticated && <IconButton >
                <DropDownIcon />
            </IconButton>}
           
        </Box> */}
        <Box
    sx={{
        // display: { sm: 'flex', xs: 'none' },
        display: 'none',
        '@media (min-width:750px)': {
            display: 'flex',
        },        
        alignItems: 'center',
        gap: '12px',
        paddingLeft: '16px',
        borderLeft: `2px solid ${colors.border.divider}`,
        marginRight: '40px',
    }}
>
    {/* Name + Role */}
    <Box sx={{ textAlign: 'right' }}>
        <Typography
            sx={{
                fontWeight: 700,
                fontSize: '15px',
                color: colors.text.primary,
                whiteSpace: 'nowrap',
                textTransform: 'capitalize',
            }}
        >
            { user?.nickname || user?.name || ''}
        </Typography>
        {/* <Typography
            sx={{
                fontWeight: 400,
                fontSize: '13px',
                color: colors.text.secondary,
                whiteSpace: 'nowrap',
            }}
        >
            {user?.role || 'Administrator'}
        </Typography> */}
    </Box>

    {/* Avatar circle */}
    <Box
        onClick={handleClick}
        sx={{
            cursor: 'pointer',
            width: 44,
            height: 44,
            borderRadius: '50%',
            backgroundColor: colors.primary.main,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            fontWeight: 700,
            fontSize: '15px',
            color: colors.primary.contrastText,
            userSelect: 'none',
        }}
    >
        {( user?.nickname || user?.name ||'')
            .split(' ')
            .filter(Boolean)
            .slice(0, 2)
            .map(w => w[0].toUpperCase())
            .join('')}
    </Box>
    <Box>
        <IconButton onClick={handleLogoutClick} ><LogoutIcon /></IconButton>
    </Box>
<Menu
  anchorEl={logoutAnchorEl}
  open={Boolean(logoutAnchorEl)}
  onClose={handleLogoutClose}
  PaperProps={{
    elevation: 0,
    sx: {
      width: 96,
      borderRadius: '6px',
      boxShadow:`0px 1px 5px 0px ${colors.border.card}`,
      mt: 1,
      overflow: 'hidden',
    },
  }}
  MenuListProps={{
    disablePadding: true,
  }}
>
  <MenuItem
    onClick={handleLogout}
    sx={{
      height: 36,
      px: 1.5,
      fontSize: 14,
      fontWeight: 400,
      color: 'text.primary',
      '&:hover': {
        bgcolor: 'action.hover',
        color: 'error.main',
      },
    }}
  >
    Logout
  </MenuItem>
</Menu>
    {/* Logout icon */}
    {/* {isAuthenticated && (
        <IconButton sx={{ color: colors.text.secondary }}>
            <LogoutIcon />
        </IconButton>
    )} */}
</Box>
      <Menu
  anchorEl={anchorEl}
  open={Boolean(anchorEl)}
  onClose={handleClose}
  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
  PaperProps={{
    sx: {
      minWidth: 160,
      borderRadius: '6px',
      boxShadow:`0px 1px 5px 0px ${colors.border.card}`,
      mt: 0.5,
    },
  }}
  MenuListProps={{
    disablePadding: true,
    sx: {
      '& .MuiMenuItem-root': {
        minHeight: 36,
        px: 2,
        fontSize: 14,
      },
      '& .MuiMenuItem-root:last-child:hover': {
        color: colors.error.main,
      },
    },
  }}
>
  <MenuItem onClick={() => handleNavigate('/settings')}>Edit Profile</MenuItem>
  <MenuItem onClick={() => handleNavigate('/settings')}>Settings</MenuItem>
</Menu>
                    </Box>

                    {/* Mobile Appbar   */}

                    <Box px={1.5} sx={{ height: '70px', 
                    // display: { sm: 'none', xs: 'flex', },
                    display: 'flex',
                        '@media (min-width:750px)': {
                            display: 'none',
                        },
                     flexDirection: 'row', justifyContent: 'space-between', alignItems: "center" }} >
                        <Box color='inherit' noWrap sx={{ flexGrow: 1 }} >
                            <IconButton
                                sx={{
                                    backgroundColor: 'Bg_color',
                                    width: '48px',
                                    height: '48px',
                                    borderRadius: '100px',
                                    fontSize: '2rem',
                                    color: colors.primary.main,
                                }}
                                onClick={() => setMobileDrawer(true)}
                            >
                                <MenuIcon fontSize='2.2rem' />
                            </IconButton>
                        </Box>
                        <Box color='inherit' sx={{ marginRight: '10px', }} >
                           <Box color='inherit' sx={{  display: 'flex', alignItems: 'center', }}>
                            <IconButton onClick={handleViewAll} sx={{ '&:hover': { backgroundColor: 'Bg_color', }, }}   >
                            {/* <IconButton disabled sx={{ backgroundColor: '#F0F7FD', '&:hover': { backgroundColor: 'Bg_color', }, }}   > */}
                                <Badge
                                    badgeContent={notificationCount}
                                    invisible={!notificationCount}
                                    sx={{
                                    '& .MuiBadge-badge': {
                                        backgroundColor: colors.error.dark,
                                        borderRadius: '100px',
                                        top: -5,
                                        right: -5, 
                                        opacity: 1,
                                        color: colors.primary.contrastText,
                                    },
                                    }}
                                >
                                    <NotificationIcon />
                                </Badge>
                                
                            </IconButton>
                        </Box>
                        </Box>
                        <Box
        onClick={handleClick}
        sx={{
            cursor: 'pointer',
            width: 44,
            height: 44,
            borderRadius: '50%',
            backgroundColor: colors.primary.main,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            fontWeight: 700,
            fontSize: '15px',
            color: colors.primary.contrastText,
            userSelect: 'none',
        }}
    >
        {( user?.nickname || user?.name ||'')
            .split(' ')
            .filter(Boolean)
            .slice(0, 2)
            .map(w => w[0].toUpperCase())
            .join('')}
                        </Box>
                            <Box sx={{marginLeft:"10px"}}>
        <IconButton onClick={handleLogoutClick} ><LogoutIcon /></IconButton>
    </Box>
<Menu
  anchorEl={logoutAnchorEl}
  open={Boolean(logoutAnchorEl)}
  onClose={handleLogoutClose}
  PaperProps={{
    elevation: 0,
    sx: {
      width: 96,
      borderRadius: '6px',
      boxShadow:`0px 1px 5px 0px ${colors.border.card}`,
      mt: 1,
      overflow: 'hidden',
    },
  }}
  MenuListProps={{
    disablePadding: true,
  }}
>
  <MenuItem
    onClick={handleLogout}
    sx={{
      height: 36,
      px: 1.5,
      fontSize: 14,
      fontWeight: 400,
      color: 'text.primary',
      '&:hover': {
        bgcolor: 'action.hover',
        color: 'error.main',
      },
    }}
  >
    Logout
  </MenuItem>
</Menu>
                    </Box>
                    <Box sx={{width:"100%"}}>
                        {/* <StyledToastContainer limit={3} /> */}
                    </Box>
                    <Box sx={{ padding: { xs: ' 10px 7px', sm: '35px 20px', md: '35px' },  flexDirection: "column", backgroundColor: colors.background.cardBg, display:"flex", justifyContent:"center" }}>
                        {children}
                    </Box>
                </Box>
            </Box >

            {/* MobileDrawer */}

            <Drawer 
            sx={{
                //  display: { xs: "-moz-initial", sm: "none" },
                  display: '-moz-initial',
    '@media (min-width:750px)': {
        display: 'none',
    },
          "& .MuiDrawer-paper": {
            borderRadius:0
          }    
        }}
                variant="temporary"
                anchor="left"
                open={mobileDrawer}
                onClose={() => setMobileDrawer(false)}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "270px",
                        borderRight: `2px solid ${colors.border.default}`,
                        minHeight: `${innerHeight - 66}px`,
                        height:"100%"
                    }}
                >
                    <Box
                        sx={{
                            display:"flex",
                            flexDirection:"column",
                            height: "100%",
                            overflowY: "auto",
                            overflowX: "hidden",
                            "&::-webkit-scrollbar": { width: "1.5px" },
                            "&::-webkit-scrollbar-track": {
                                boxShadow: ` inset 0 0 1.5px ${colors.border.light}`,
                            },
                        }}
                    >
                        <Box my={1} sx={{ height: '60px', padding: '8px 8px 6px 8px', display:"flex", justifyContent:"center" }} >
                            {/* <Logo width='127px' height='33px' /> */}
                            <MobileLogo width='161px' height='36px' />
                        </Box>

                        <List>
                            {/* <Typography mb={2} sx={{ fontSize: '15px', fontWeight: 600, letterSpacing: '.3px', color: colors.nav.labelColor, textAlign: 'center' }}>Portfolios</Typography> */}
                            {menus.map((item) => {
                                return (
                                    <>
                                        <NavLink to={item?.uri_link} onClick={() => setMobileDrawer(false)}>
                                            <ListItemButton sx={{margin:"0 18px", borderRadius:"4px", height: '54px', ".MuiListItemText-primary": { color: location?.pathname == item?.uri_link && colors.primary.main }, backgroundColor: location?.pathname == item?.uri_link && colors.nav.activeBackground,  '&:hover': { ".MuiListItemText-primary": { color: colors.nav.activeColor }, backgroundColor: colors.nav.activeBackground } }}>
                                                <Tooltip >
                                                    <ListItemIcon sx={{ minWidth: '40px' }}>
                                                        { location?.pathname == item?.uri_link ? item?.focused_icon : item?.icon_sm}
                                                    </ListItemIcon>
                                                </Tooltip>
                                                <ListItemText className='fade-in' sx={{ ".MuiTypography-root": { fontSize: '15px', fontWeight: '500 ', letterSpacing: '.7px', color: location?.pathname == item?.uri_link ? colors.nav.activeColor : colors.text.gray, '&:hover': { color: colors.primary.main } } }} primary={item?.nav_bar_name} />
                                            </ListItemButton>
                                        </NavLink>
                                        {/* {item?.nav_bar_name == 'Transactions' &&
                                            <Typography my={2} sx={{ fontSize: '15px', fontWeight: 600, letterSpacing: '.3px', color: colors.nav.labelColor, textAlign: 'center' }}>Support</Typography>
                                        } */}
                                    </>
                                )
                            })}
                        </List>


                        <Box sx={{ flexGrow:1, display:"flex", flexDirection:"column", justifyContent:"flex-end", height:"100%"}}>
                            <Box sx={{display:"flex",justifyContent:"center"}}>
                                <Box component={'img'} sx={{width:"70px",height:"70px"}} src={BottomLogo} />
                            </Box>
                            <hr style={{ color: colors.text.disabled }} />
                            <Box sx={{ padding: '0 20px 20px 20px', display: 'flex', flexDirection: 'column', gap: '10px', justifyContent:"flex-end", }}>
                                <Typography sx={{ fontWeight: 500, fontSize: '13px', color: colors.text.primary, lineHeight: '16px', letterSpacing: '2%' }}>© TradeTogether. {currentYear}</Typography>
                                <Typography sx={{ fontWeight: 500, fontSize: '10px', color: colors.text.secondary, lineHeight: '12px', letterSpacing: '5%' }}>TradeTogether is the platform for trading and exchanging currencies.</Typography>
                                <Box sx={{ display: 'flex', gap: '10px' }}>
                                    <Typography sx={{ cursor: 'pointer', color: colors.text.tertiary, letterSpacing: '5%', fontSize: '10px', lineHeight: '12px', fontWeight: '500' }}>Terms & Condition</Typography>
                                    <Typography sx={{ color: colors.neutral.outlinedText, fontSize: '20px', marginTop: '-15px' }}>.</Typography>
                                    <Typography sx={{ cursor: 'pointer', color: colors.text.tertiary, letterSpacing: '5%', fontSize: '10px', lineHeight: '12px', fontWeight: '500' }}>Privacy Policy</Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box >
                </Box >
            </Drawer>
        </Box >

    )
}

export default SideBar